import { useQuery } from "@apollo/client/react";
import GET_PERMISSIONS from "../queries/getPermissions";

interface PermissionsResponseModel {
  available: {
    readPermissions: string[];
    writePermissions: string[];
  };
  availableForCurrentUser: {
    readPermissions: string[];
    writePermissions: string[];
  };
}

export const usePermissions = () => {
  const { data, error, loading, refetch } = useQuery<{
    permissions: PermissionsResponseModel;
  }>(GET_PERMISSIONS, {
    fetchPolicy: "cache-first",
  });
  return { permissions: data?.permissions, error, loading, refetch };
};
